import { render } from "./RegisterFooter.vue?vue&type=template&id=042d5e60&scoped=true&lang=pug"
import script from "./RegisterFooter.vue?vue&type=script&lang=js"
export * from "./RegisterFooter.vue?vue&type=script&lang=js"

import "./RegisterFooter.vue?vue&type=style&index=0&id=042d5e60&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042d5e60"]])

export default __exports__